module.exports = __webpack_public_path__ + "static/img/an1_tzjx_icon.png";